// src/pages/Pedido/Endereco.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FaChevronRight, FaMoneyBillWave } from "react-icons/fa";
import { useApi } from '../../hooks/useApi';
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import './Endereco.css';  // Importar o arquivo CSS externo.
import MainContent from '../../components/Form/MainContent';
import { formatCurrency } from '../../utils/numberUtils';
import Modal from '../../components/Modal/Modal'; // Importa o Modal
import { useAuth } from '../../contexts/AuthContext'; // Importando o hook useAuth
import { useCart } from '../../contexts/CartContext';
import { useTheme } from '../../contexts/ThemeContext';
import { normalizeNullableInputValue, normalizeNullableText } from '../../utils/stringUtils';
import { formatPhoneNumber, getPhoneDigits, isValidPhoneNumber } from '../../utils/phoneUtils';
import { useTaxasEntregaBairro } from '../../hooks/useTaxasEntregaBairro';

import { reconciliarCidadeEntrega, reconciliarBairroEntrega } from '../../utils/enderecoEntregaUtils';

import brFlag from '../../assets/flags/br.png'; // bandeira Brasil
import arFlag from '../../assets/flags/ar.png'; // bandeira Argentina
import deliverySticker from '../../assets/images/delivery-sticker.png';
import pickupSticker from '../../assets/images/pickup-sticker.png';
import dineInSticker from '../../assets/images/dine-in-sticker.png';
import { tipoEntregaEhConsumoLocal, tipoEntregaTemTaxa } from '../../utils/tipoEntregaUtils';

const Endereco = () => {  
  const { fetchData, postData } = useApi();

  //Validação telefone e cliente
  const [telefoneCliente, setTelefoneCliente] = useState('');
  const [telefoneError, setTelefoneError] = useState(false);
  const [telefoneErrorMessage, setTelefoneErrorMessage] = useState('Informe um telefone válido.');

  const [selectedCountry, setSelectedCountry] = useState({
    code: '+55',
    name: 'BR',
    flag: brFlag,
  });

  const countries = [
    { code: '+55', name: 'BR', flag: brFlag },
    { code: '+54', name: 'AR', flag: arFlag },
  ];

  const handleCountryChange = (e) => {
    const country = countries.find(c => c.code === e.target.value);
    if (country) {
      setSelectedCountry(country);
      setTelefoneCliente(''); // limpa ao trocar país
    }
  };
    
  const [nomeCliente, setNomeCliente] = useState(''); // State for name
  const [nomeError, setNomeError] = useState(false); // State for name error

  const [taxaEntrega, setTaxaEntrega] = useState(0);
  const [endereco, setEndereco] = useState({logradouro:"", numero:"", bairro:"", complemento:"", cidadeId:null});
  let nomeCidade, uF;
  const [enderecoCliente, setEnderecoCliente] = useState();  
  const [showModalInput, setShowModalInput] = useState(false); // Estado para o modal de endereço
  const [tiposEntrega, setTiposEntrega] = useState([]);
  const [cidadesEntrega, setCidadesEntrega] = useState([]);
  const [tipoEntrega, setTipoEntrega] = useState();
  const [tipoEntregaError, setTipoEntregaError] = useState(false);
  const [modalMessage, setModalMessage] = useState(''); // Estado para o modal
  const navigate = useNavigate();  
  const { isAuthenticated } = useAuth(); // Usando o contexto para verificar autenticação
  const { cartItemTotal } = useCart();
  const { configModulo, loadingTheme } = useTheme();
  const [cidadesCarregadas, setCidadesCarregadas] = useState(false);
  const usaTaxaEntregaBairro = configModulo?.taxaEntregaBairro === true;
  const {
    taxasEntregaBairro,
    carregandoTaxasBairro,
    erroTaxasBairro,
    carregarTaxasEntregaBairro,
  } = useTaxasEntregaBairro(endereco?.cidadeId, usaTaxaEntregaBairro && tipoEntregaTemTaxa(tipoEntrega) && cidadesCarregadas && cidadesEntrega.some((cidade) => Number(cidade.id) === Number(endereco?.cidadeId)));
  const [appDesconto, setAppDesconto] = useState(0);
  const [cashBackInfo, setCashBackInfo] = useState(null);
  const [usarCashBack, setUsarCashBack] = useState(false);

  const limparCalculoEntrega = () => {
    setTaxaEntrega(0);
    setEndereco((prev) => prev.taxaEntregaBairroId
      ? { ...prev, taxaEntregaBairroId: null }
      : prev);
    localStorage.removeItem('taxaEntregaBairroId');
    localStorage.removeItem('distance');
    localStorage.removeItem('coordsDest');
    localStorage.removeItem('enderecoCliente');
  };


  useEffect(() => {    
    const telefoneSalvo = localStorage.getItem('telefoneClienteInput');
    const telefonesParaLimpar = ['55996811751', '5596811751'];

    if (telefonesParaLimpar.includes(getPhoneDigits(telefoneSalvo))) {
      localStorage.removeItem('telefoneClienteInput');
    }

    const fetchDataFromAPI = async () => {      
      try {                       
        if (isAuthenticated) {
          const result = await fetchData('/EnderecoApp');
          if (result!=null) {
            setEndereco(result);
          }                  
        }
      } catch (error) {
        console.log("Erro ao buscar cliente:" + error);
      }      
    };
    
    const fetchTipoEntrega = async () => {
      try {
        const result = await fetchData('/TipoEntregaDelivery');
        const tiposDisponiveis = Array.isArray(result) ? result : [];
        setTiposEntrega(tiposDisponiveis);

        let tipoEnt = null;
        try {
          tipoEnt = JSON.parse(localStorage.getItem('tipoEntrega'));
        } catch (error) {
          localStorage.removeItem('tipoEntrega');
        }

        const tipoAtual = tipoEnt
          ? tiposDisponiveis.find((tipo) => Number(tipo.id) === Number(tipoEnt.id))
          : null;

        if (tiposDisponiveis.length === 1) {
          const tipoDisponivel = tiposDisponiveis[0];
          const taxaEntregaSalva = tipoAtual && tipoEntregaTemTaxa(tipoDisponivel)
            ? Number(tipoEnt?.taxaEntrega || 0)
            : 0;
          const tipoEntregaUnico = {
            ...tipoDisponivel,
            taxaEntrega: taxaEntregaSalva,
          };

          setTipoEntrega(tipoEntregaUnico);
          setTaxaEntrega(tipoEntregaUnico.taxaEntrega);
          localStorage.setItem('tipoEntrega', JSON.stringify(tipoEntregaUnico));
          if (!tipoEntregaTemTaxa(tipoEntregaUnico)) limparCalculoEntrega();
        } else if (tipoAtual) {
          const tipoEntregaAtual = {
            ...tipoAtual,
            taxaEntrega: tipoEntregaTemTaxa(tipoAtual) ? Number(tipoEnt?.taxaEntrega || 0) : 0,
          };
          setTipoEntrega(tipoEntregaAtual);
          setTaxaEntrega(tipoEntregaAtual.taxaEntrega);
          localStorage.setItem('tipoEntrega', JSON.stringify(tipoEntregaAtual));
          if (!tipoEntregaTemTaxa(tipoEntregaAtual)) limparCalculoEntrega();
        } else {
          setTipoEntrega(undefined);
          localStorage.removeItem('tipoEntrega');
          limparCalculoEntrega();
        }
        
      } catch (error) {
        console.log("Erro ao buscar tipos de entrega:" + error);
      }
    };

    const fetchCidadesEntrega = async () => {
      try {
        const result = await fetchData('/Cidade/CidadesDelivery');
        setCidadesEntrega(Array.isArray(result) ? result : []);
        setCidadesCarregadas(true);
        
      } catch (error) {
        console.log("Erro ao buscar tipos de entrega:" + error);
      }
    };

    const fetchDesconto = async () => {
      try {
        const result = await fetchData('/ConfigPedido');
        if (result.appDesconto)
        {
          setAppDesconto(result.appDesconto);
          //setValorDesconto(cartItemTotal*(result.appDesconto/100))
        }

        const telefoneSalvo = localStorage.getItem('telefoneClienteInput');
        if (telefoneSalvo) {
          const cashBackResult = await fetchData('/CashBack/Saldo', { telefone: telefoneSalvo });
          setCashBackInfo(cashBackResult);
        }
        
      } catch (error) {
        console.log("Erro ao buscar o desconto:" + error);
      }
    };

    const preencheDadosCliente = async () => {
      //Contato do cliente
      setNomeCliente(localStorage.getItem('nomeClienteInput') || '');
      
      // Carrega o código do país e o número de telefone separadamente
      const savedCountryCode = localStorage.getItem('countryCodeInput') || '+55';
      const country = countries.find(c => c.code === savedCountryCode) || countries[0];
      const savedPhone = localStorage.getItem('telefoneClienteInput') || '';
      setSelectedCountry(country);
      setTelefoneCliente(formatPhoneNumber(savedCountryCode, savedPhone));

      //Endereço do cliente
      if (['logradouroInput', 'numeroInput', 'bairroInput', 'complementoInput', 'cidadeIdInput'].some((chave) => localStorage.getItem(chave)))
      {      
        //Cidade default tanto faz o nome pois não vai aparecer no app
        // No modo por bairro, a cidade será reconciliada com o cadastro atual.
        //Busca a Cidade
        const idCidade = parseInt(localStorage.getItem('cidadeIdInput'));           
        const cidadeInput = localStorage.getItem('cidadeInput');

        let cidadeSel = null;
        if (cidadeInput && cidadeInput !== 'undefined') {
          try {
            cidadeSel = JSON.parse(cidadeInput);
          } catch (e) {
            console.warn('cidadeInput inválido no localStorage', cidadeInput);
          }
        }


        setEndereco(prev => ({ ...prev, 
          id: 1,
          logradouro: normalizeNullableText(localStorage.getItem('logradouroInput')), 
          numero: normalizeNullableText(localStorage.getItem('numeroInput')), 
          bairro: normalizeNullableText(localStorage.getItem('bairroInput')),
          complemento: normalizeNullableText(localStorage.getItem('complementoInput')),
          cidadeId: idCidade || null,
          taxaEntregaBairroId: Number(localStorage.getItem('taxaEntregaBairroId')) || null,
          cidade: cidadeSel }));            
      }
    };

    fetchCidadesEntrega();
    fetchDataFromAPI();
    fetchTipoEntrega();
    fetchDesconto();
    preencheDadosCliente();
  }, []);

  useEffect(() => {
    if (loadingTheme) return;
    if (!usaTaxaEntregaBairro) {
      setEndereco((prev) => prev.cidadeId ? prev : { ...prev, cidadeId: 1 });
      return;
    }
    if (!cidadesCarregadas) return;
    const cidade = reconciliarCidadeEntrega(endereco?.cidadeId, cidadesEntrega);
    if (endereco?.cidadeId !== (cidade?.id ?? null) || endereco?.cidade !== cidade) {
      setEndereco((prev) => ({ ...prev, cidadeId: cidade?.id ?? null, cidade }));
    }
  }, [loadingTheme, usaTaxaEntregaBairro, cidadesCarregadas, cidadesEntrega, endereco?.cidadeId, endereco?.cidade]);

  useEffect(() => {
    if (!tipoEntrega) return;

    if (!tipoEntregaTemTaxa(tipoEntrega)) {
      limparCalculoEntrega();
      if (tipoEntrega && Number(tipoEntrega.taxaEntrega || 0) !== 0) {
        const atualizado = { ...tipoEntrega, taxaEntrega: 0 };
        setTipoEntrega(atualizado);
        localStorage.setItem('tipoEntrega', JSON.stringify(atualizado));
      }
      return;
    }

    if (!usaTaxaEntregaBairro || carregandoTaxasBairro || erroTaxasBairro || !cidadesCarregadas) return;
    const cidade = reconciliarCidadeEntrega(endereco?.cidadeId, cidadesEntrega);
    if (cidade && Number(cidade.id) !== Number(endereco?.cidadeId)) return;
    const taxa = reconciliarBairroEntrega(endereco, taxasEntregaBairro);
    const id = taxa ? Number(taxa.id) : null;
    if (endereco.taxaEntregaBairroId !== id || (taxa && endereco.bairro !== taxa.descricao)) {
      setEndereco((prev) => ({ ...prev, taxaEntregaBairroId: id, bairro: taxa?.descricao ?? prev.bairro }));
    }
    const valor = Number(taxa?.valor || 0);
    setTaxaEntrega(valor);
    if (id) localStorage.setItem('taxaEntregaBairroId', id);
    else localStorage.removeItem('taxaEntregaBairroId');
    localStorage.removeItem('distance');
    localStorage.removeItem('coordsDest');
    if (tipoEntrega && tipoEntrega.taxaEntrega !== valor) {
      const atualizado = { ...tipoEntrega, taxaEntrega: valor };
      setTipoEntrega(atualizado);
      localStorage.setItem('tipoEntrega', JSON.stringify(atualizado));
    }
  }, [usaTaxaEntregaBairro, cidadesCarregadas, cidadesEntrega, carregandoTaxasBairro, erroTaxasBairro, taxasEntregaBairro, endereco, tipoEntrega]);

  const taxasBairroCidade = taxasEntregaBairro.filter((item) => Number(item.cidadeId) === Number(endereco?.cidadeId));

  const handleTaxaEntregaBairroChange = (event) => {
    const id = Number(event.target.value) || null;
    const taxa = taxasEntregaBairro.find((item) => Number(item.id) === id);
    setEndereco((prev) => ({ ...prev, taxaEntregaBairroId: id, bairro: taxa?.descricao || '' }));
    setTaxaEntrega(Number(taxa?.valor || 0));
    if (id) localStorage.setItem('taxaEntregaBairroId', id);
    else localStorage.removeItem('taxaEntregaBairroId');
  };

  useEffect(() => {
    if (showModalInput && !usaTaxaEntregaBairro)
    {
      setEndereco(prev => ({ ...prev, 
        id: 1,
        logradouro: normalizeNullableText(localStorage.getItem('logradouroInput')), 
        numero: normalizeNullableText(localStorage.getItem('numeroInput')), 
        bairro: normalizeNullableText(localStorage.getItem('bairroInput')),
        complemento: normalizeNullableText(localStorage.getItem('complementoInput')) }));
    }
    
  }, [showModalInput]);

  useEffect(() => {
    if (enderecoCliente)
    {
      handleCheckout();
    }
  }, [enderecoCliente]);

  const handleCadastrarEndereco = () => {    
    if (!isAuthenticated) {
      if (usaTaxaEntregaBairro) carregarTaxasEntregaBairro();
      setShowModalInput(true); // Exibe o modal para clientes não autenticados
    } else {
      navigate('/cadastrar-endereco', { state: { endereco } });
    }
  };

  const handleSaveEndereco = async ()  => {
    if (usaTaxaEntregaBairro && (carregandoTaxasBairro || erroTaxasBairro || !reconciliarBairroEntrega(endereco, taxasBairroCidade))) {
      setModalMessage('Selecione um bairro com taxa de entrega cadastrada.');
      return;
    }
    const enderecoNormalizado = {
      ...endereco,
      logradouro: normalizeNullableText(endereco.logradouro),
      numero: normalizeNullableText(endereco.numero),
      bairro: normalizeNullableText(endereco.bairro),
      complemento: normalizeNullableText(endereco.complemento),
    };

    localStorage.setItem('logradouroInput', enderecoNormalizado.logradouro);
    localStorage.setItem('numeroInput', enderecoNormalizado.numero);
    localStorage.setItem('bairroInput', enderecoNormalizado.bairro);  
    localStorage.setItem('complementoInput', enderecoNormalizado.complemento);
    localStorage.setItem('cidadeIdInput', enderecoNormalizado.cidadeId);    
    localStorage.setItem('cidadeInput', JSON.stringify(enderecoNormalizado.cidade));    
    if (enderecoNormalizado.taxaEntregaBairroId) localStorage.setItem('taxaEntregaBairroId', enderecoNormalizado.taxaEntregaBairroId);

    setEndereco(enderecoNormalizado);
    setEnderecoCliente(enderecoNormalizado);     
    setShowModalInput(false);
  };  

  const calculaDistancia = async (tipo) => {
    if (usaTaxaEntregaBairro) {
      const taxa = taxasEntregaBairro.find((item) => Number(item.id) === Number(endereco.taxaEntregaBairroId) && Number(item.cidadeId) === Number(endereco.cidadeId));
      if (!taxa) {
        setModalMessage('Selecione um bairro com taxa de entrega cadastrada.');
        return false;
      }

      const cidade = cidadesEntrega.find((item) => Number(item.id) === Number(endereco.cidadeId));
      const valorEntrega = Number(taxa.valor || 0);
      setTaxaEntrega(valorEntrega);
      localStorage.removeItem('distance');
      localStorage.removeItem('coordsDest');
      localStorage.setItem('taxaEntregaBairroId', taxa.id);
      localStorage.setItem('tipoEntrega', JSON.stringify({ ...tipo, taxaEntrega: valorEntrega }));
      localStorage.setItem('enderecoCliente', endereco.logradouro + ', nº: ' + endereco.numero +
        ', Bairro: ' + taxa.descricao +
        (normalizeNullableText(endereco.complemento) ? ', Complemento: ' + normalizeNullableText(endereco.complemento) : '') +
        (cidade ? ', ' + cidade.nome : ''));
      return true;
    }

    //Pega longitude e latitude da origem
    let configPedido;
    let coordsOrig;
    try {
      configPedido = await fetchData('/ConfigPedido');  
      coordsOrig = [configPedido.latitude, configPedido.longitude]
    } catch (error) {
      console.error('Erro ao obter configPedido:', error);
      setErrorMessage('Falha ao carregar os dados do configPedido.');
    }

    //Pega longitude e latitude do destino
    const coordsDest = await handleOrigin2Search();
    localStorage.setItem('coordsDest', coordsDest);

    //Pega a distancia
    //const distance = await getDistance(coordsOrig, coordsDest);

    try {
      let url = `/TaxaEntrega/GetDistance?latOrig=${coordsOrig[0]}&lonOrig=${coordsOrig[1]}&latDest=${coordsDest[0]}&lonDest=${coordsDest[1]}`;
      const distancia = await fetchData(url);
      localStorage.setItem('distance', distancia);

      url = `/TaxaEntrega/CalcTaxaEntrega?distancia=${distancia}`;
      const valorEntrega = await fetchData(url);
      setTaxaEntrega(valorEntrega);
      let tipoEntregaSave = tipo;
      tipoEntregaSave = {...tipoEntregaSave, taxaEntrega:valorEntrega};    
      localStorage.setItem('tipoEntrega', JSON.stringify(tipoEntregaSave));//limpa tipoEntrega

    } catch (error) {
      console.error('Erro ao obter distância:', error);
      return false;
    }

    if (endereco.cidadeId!=1) {

      localStorage.setItem('enderecoCliente', endereco.logradouro+', nº: '+endereco.numero+
        (endereco.bairro ? ', Bairro: '+endereco.bairro : '' )+
        (normalizeNullableText(endereco.complemento) ? ', Complemento: '+normalizeNullableText(endereco.complemento) : '')
        +', '+ nomeCidade);
    } else {
       localStorage.setItem('enderecoCliente', endereco.logradouro+', nº: '+endereco.numero+
        (endereco.bairro ? ', Bairro: '+endereco.bairro : '')+
        (normalizeNullableText(endereco.complemento) ? ', Complemento: '+normalizeNullableText(endereco.complemento) : ''));
    }
    return true;
  }

  const handleOrigin2Search = async () => {
    if (!/\d+/.test(endereco.numero)) {
      alert('Inclua o número no endereço para maior precisão.');
      return;
    }

    if (endereco.logradouro==!"") {
      alert('Inclua o logradouro do endereço para maior precisão.');
      return;
    }

    //pega o nome da cidade
    const cidade = cidadesEntrega.find(c => c.id === endereco.cidadeId); // Usar 'find' para obter o primeiro objeto correspondente
    nomeCidade = cidade ? cidade.nome : 'Cidade não encontrada'; // Verificar se a cidade existe
    uF = cidade ? cidade.uf : ''; // Verificar se a cidade existe
  
    const coords = await geocodeAddress(endereco.logradouro+', '+endereco.numero+', '+endereco.bairro+', '+nomeCidade+' - '+uF);
    if (coords) {
      return coords;
     } else {
      alert('Endereço não encontrado');
    }
  };
  
  const GOOGLE_API_KEY = 'AIzaSyCftZJ17gqIww9m1mCCtlznA5sXvA536G4';
  
  const geocodeAddress = async (address) => {
    const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${GOOGLE_API_KEY}`);
    const data = await res.json();
    
    if (data.status === 'OK' && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      return [lat, lng];
    }
    return null;
  };

  const handleEntregaClick = (tipo) => {
    const tipoSelecionado = {
      ...tipo,
      taxaEntrega: tipoEntregaTemTaxa(tipo) ? Number(tipo.taxaEntrega || 0) : 0,
    };
    setTipoEntrega(tipoSelecionado);
    setTipoEntregaError(false);
    if (tipoEntregaTemTaxa(tipoSelecionado)) {
      if (endereco.id && endereco.logradouro && endereco.numero && endereco.bairro) { 
        calculaDistancia(tipoSelecionado);
      }    
    } else {
      limparCalculoEntrega();
      localStorage.setItem('tipoEntrega', JSON.stringify(tipoSelecionado));
    }
  };

  const validarTelefoneWhatsApp = async () => {
    const phoneDigits = telefoneCliente.replace(/\D/g, '');
    const telefoneValidacao = `${selectedCountry.code.replace('+', '')}${phoneDigits}`;

    try {
      const result = await postData('/WhatsAppWeb/CheckWhatsNumber', {
        telefone: telefoneValidacao,
      });

      if (!result?.existe) {
        setTelefoneError(true);
        setTelefoneErrorMessage('Telefone sem WhatsApp cadastrado.');
        return false;
      }

      return true;
    } catch (error) {
      console.error('Erro ao validar telefone no WhatsApp:', error);
      setTelefoneError(true);
      setTelefoneErrorMessage('Não foi possível validar o telefone no momento.');
      return false;
    }
  };

  const handleCheckout = async () => {    
    // Reset error states
    setNomeError(false);
    setTelefoneError(false);
    setTipoEntregaError(false);

    if (!telefoneCliente) {
      setTelefoneError(true);
      setTelefoneErrorMessage('Telefone obrigatório.');
      return;
    }

    // Validação diferente para cada país
    if (!isValidPhoneNumber(selectedCountry.code, telefoneCliente)) {
      setTelefoneError(true);
      setTelefoneErrorMessage('Informe um telefone válido.');
      return;
    }

    if (!tipoEntrega) {
      setTipoEntregaError(true);
      return;
    }

    // Validate customer name and phone
    if (!nomeCliente) {
      setNomeError(true);      
      //setModalMessage('Informe seu nome!');
      return;
    }

    if (tipoEntregaTemTaxa(tipoEntrega)) {
      if (usaTaxaEntregaBairro && !endereco?.taxaEntregaBairroId) {
        setModalMessage('Selecione um bairro com taxa de entrega cadastrada.');
        handleCadastrarEndereco();
        return;
      }
      if (!endereco.logradouro) {
        setModalMessage('Por favor, informe o endereço.'); // Exibe o modal
        return;
      }

      if (!endereco.numero) {
        setModalMessage('Por favor, informe o número.'); // Exibe o modal
        return;
      }
      
      if (!tipoEntrega) {
        setModalMessage('Por favor, selecione um tipo de entrega.'); // Exibe o modal
        return;
      }
    }

    // Salva apenas o número de telefone e o código do país separadamente
    localStorage.setItem('telefoneClienteInput', telefoneCliente);
    localStorage.setItem('countryCodeInput', selectedCountry.code);
    localStorage.setItem('nomeClienteInput', nomeCliente); // Save name to localStorage

    //Dados entrega
    localStorage.setItem('tipoEntrega', JSON.stringify(tipoEntrega));//limpa tipoEntrega
    if (appDesconto>0)
      localStorage.setItem('valorDesconto', JSON.stringify(valorDescontoCalculado));
    else
      localStorage.setItem('valorDesconto', JSON.stringify(0));

    localStorage.setItem('valorCashBack', JSON.stringify(valorCashBackAplicado));

    if (tipoEntregaTemTaxa(tipoEntrega)) {
      if (isAuthenticated) {
        if (!endereco || endereco.length === 0) {
          setModalMessage('Por favor, cadastre um endereço primeiro.'); // Exibe o modal
          return; 
        }
      } else {
        if (!endereco.id && endereco.logradouro && endereco.numero && endereco.bairro) {        
          //setModalMessage('Por favor, informe um endereço primeiro.'); // Exibe o modal
          handleCadastrarEndereco();
          if (!enderecoCliente)
          return;
        }
      }
      const calculado = await calculaDistancia(tipoEntrega);
      if (calculado === false) return;
    }

    // if (tipoEntrega && tipoEntrega.descricao !== "Retirada") {
    //   // só grava o endereço se for retirada      
    //   if (isAuthenticated) {
    //     localStorage.setItem('endereco', JSON.stringify(endereco)); // com login endereço da base    
    //   }
    // }
    navigate('/pagamento');
  };

  const closeModal = () => setModalMessage(''); // Fecha o modal

  const isCheckoutDisabled = false; // Habilitação do botão de checkout

  const valorDescontoCalculado = appDesconto > 0 ? cartItemTotal * (appDesconto / 100) : 0;
  const totalAntesCashBack = (cartItemTotal - valorDescontoCalculado) + taxaEntrega;
  const valorCashBackAplicado = usarCashBack ? Math.min(cashBackInfo?.saldo || 0, totalAntesCashBack) : 0;
  const totalAPagar = Math.max(totalAntesCashBack - valorCashBackAplicado, 0);

  return (
    <>
      <Header titulo="Dados para Entrega" />
      <MainContent className="endereco-main">
        <section className="endereco-page">
        <div className="endereco-flow">
        {!isAuthenticated && (
        <div className="dados-cliente-container">
          <div className="endereco-section-heading">
            <span className="endereco-section-marker" aria-hidden="true" />
            <div>
              <h2>Seus dados</h2>
              <p>Usaremos estas informações para identificar o pedido.</p>
            </div>
          </div>
          <div className="input-container phone-container">
            <div className="phone-row">
              <select
                value={selectedCountry.code}
                onChange={handleCountryChange}
                className="country-select"              
              >
                {countries.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.name}
                  </option>
                ))}
              </select>

              <img
                src={selectedCountry.flag}
                alt={selectedCountry.name}
                className="country-flag"
              />

              <input
                type="tel"
                value={telefoneCliente}
                maxLength={selectedCountry.code === '+55' ? 15 : 16}
                onChange={(e) => {
                  setTelefoneCliente(formatPhoneNumber(selectedCountry.code, e.target.value));
                  setTelefoneError(false);
                  setTelefoneErrorMessage('Informe um telefone válido.');
                }}
                className={`dados-cliente-input masked ${telefoneError ? 'input-error' : ''}`}
                placeholder={selectedCountry.code === '+54' ? '9 9999 99-9999' : 'Telefone'}
              />
            </div>
            {telefoneError && <span className="error-label">{telefoneErrorMessage}</span>}
          </div>

          <div className="input-container endereco-name-field">
            <input
              type="text"
              placeholder="Nome e Sobrenome"
              value={nomeCliente}
              onChange={(e) => {
                setNomeCliente(e.target.value);
                setNomeError(false); // Clear error when user types
              }}
              className={`dados-cliente-input ${nomeError ? 'input-error' : ''}`}              
            />
            {nomeError && <span className="error-label">Nome obrigatório</span>}
          </div>
        </div>
        )}        

        <div className={`entrega-buttons-container endereco-section ${tipoEntregaError ? 'tipo-entrega-error' : ''}`}>
          <div className="endereco-section-heading">
            <span className="endereco-section-marker" aria-hidden="true" />
            <div>
              <h2>Como você quer receber?</h2>
              <p>Escolha entrega, retirada ou consumo no estabelecimento.</p>
            </div>
          </div>
          
          {tiposEntrega.map((tipo) => {
            const isSelected = tipoEntrega?.id === tipo.id;
            const stickerImage = tipoEntregaEhConsumoLocal(tipo)
              ? dineInSticker
              : tipoEntregaTemTaxa(tipo)
                ? deliverySticker
                : pickupSticker;

            return (
              <button
                key={tipo.id}
                type="button"
                className={`tipoEntrega-button ${isSelected ? 'selected' : ''}`}
                onClick={() => handleEntregaClick(tipo)}
                aria-pressed={isSelected}
              >
                {/* Desabilita apenas o botão selecionado */}
                <img
                  src={stickerImage}
                  alt=""
                  className="tipoEntrega-sticker"
                />
                <span>{tipo.descricao}</span>
              </button>
            );
          })}
          {tipoEntregaError && <span className="error-label tipo-entrega-error-label">Informe um tipo de entrega</span>}
        </div>

        {/* Endereço */}
        {tipoEntregaTemTaxa(tipoEntrega) && (
          <div className="endereco-address-section endereco-section">
            <div className="endereco-section-heading">
              <span className="endereco-section-marker" aria-hidden="true" />
              <div>
                <h2>Endereço</h2>
                <p>Confira o local antes de seguir para o pagamento.</p>
              </div>
            </div>
            <button type="button" key={endereco.id} className="endereco-address-card" onClick={handleCadastrarEndereco}>
              <span className="endereco-address-icon" aria-hidden="true">
                <HiOutlineLocationMarker color={endereco.id ? '#505050' : '#ffd901'} size={40} />
              </span>
              {endereco.id ? (
                <div className="enderecoContainer">
                  <p className="enderecoItemTitulo">{endereco.logradouro}, {endereco.numero}</p>
                  <p>Bairro {endereco.bairro}</p>                  
                  {normalizeNullableText(endereco.complemento) && <p>{normalizeNullableText(endereco.complemento)}</p>}
                  {endereco.cidadeId!=1 && <p className="enderecoCidade">{endereco.cidade?.nome}/{endereco.cidade?.uf}</p>} 
                </div>
              ) : (
                <p className="enderecoItemTitulo">{isAuthenticated ? "Cadastrar endereço" : enderecoCliente ? enderecoCliente.logradouro: "Informar endereço"}</p>
              )}
              <span className="endereco-address-chevron" aria-hidden="true">
                <FaChevronRight size={20} />
              </span>
            </button>
          </div>
        )}
        </div>

        <aside className="total-container endereco-summary" aria-label="Resumo do pedido">
          <div className="endereco-summary-heading">
            <span>Resumo</span>
            <small>Confira os valores</small>
          </div>
          <div className="total-linha">
            <p className="total-second">Pedido: </p>
            <p className="total-second">{formatCurrency(cartItemTotal)}</p>
          </div>
          {appDesconto > 0 && (
          <div className="total-linha">
            <p className="total-second">Desconto: </p>
            <p className="total-second">{formatCurrency(valorDescontoCalculado)}</p>
          </div>)}
          {cashBackInfo?.saldo > 0 && (
          <div className="total-linha">
            <p className="total-second">CashBack disponível: </p>
            <p className="total-second">{formatCurrency(cashBackInfo.saldo)}</p>
          </div>
          )}
          {cashBackInfo?.saldo > 0 && (
          <button
            type="button"
            className={`cashback-button ${usarCashBack ? 'active' : ''}`}
            aria-pressed={usarCashBack}
            onClick={() => setUsarCashBack((valorAtual) => !valorAtual)}
          >
            <span className="cashback-button-icon" aria-hidden="true">
              <FaMoneyBillWave />
            </span>
            <span className="cashback-button-content">
              <span className="cashback-button-label">
                {usarCashBack ? 'Cashback aplicado' : 'Usar cashback'}
              </span>
              <span className="cashback-button-description">
                {usarCashBack ? 'Toque para remover' : `Economize até ${formatCurrency(cashBackInfo.saldo)}`}
              </span>
            </span>
            <span className="cashback-button-status" aria-hidden="true">
              {usarCashBack ? '✓' : '+'}
            </span>
          </button>
          )}
          {valorCashBackAplicado > 0 && (
          <div className="total-linha">
            <p className="total-second">CashBack: </p>
            <p className="total-second">-{formatCurrency(valorCashBackAplicado)}</p>
          </div>
          )}
          {tipoEntregaTemTaxa(tipoEntrega) && (taxaEntrega > 0 || (usaTaxaEntregaBairro && endereco?.taxaEntregaBairroId)) && (
          <div className="total-linha">
            <p className="total-second">Taxa de Entrega: </p>
            <p className="total-second">{formatCurrency(taxaEntrega)}</p>
          </div>
          )}
          <div className="total-linha">
            <p className="total-title">Total a Pagar: </p>
            <p className="total-title">{formatCurrency(totalAPagar)}</p>
          </div>
          <button
            className="checkout-button"
            disabled={isCheckoutDisabled} // Desabilita se pagamento ou entrega não estiverem selecionados
            onClick={handleCheckout}
          >
            Ir para Pagamento <FaMoneyBillWave className="checkout-button-icon" />
          </button>
        </aside>
        </section>
      </MainContent>

      <Footer />

      <Modal 
        show={!!modalMessage} 
        onClose={closeModal} 
        message={modalMessage} 
      />

      <Modal 
        show={showModalInput} 
        //onClose={() => setShowModalInput(false)} 
        //message={modalMessage} 
        titulo="Informe seu Endereço"
        className="endereco-modal"
      >
        <p className="endereco-modal-description">Confira onde você deseja receber seu pedido.</p>
        <div className="endereco-modal-form">
          <div className="endereco-modal-field">
            <label htmlFor="endereco-cidade">Cidade</label>
            <select
              id="endereco-cidade"
              className="modal-texto-input"
              value={(endereco?.cidadeId ?? '').toString()}
              onChange={(e) => {
                const id = Number(e.target.value) || null;
                const cidadeSel = cidadesEntrega.find(c => Number(c.id) === id);
                setEndereco((prev) => ({
                  ...prev,
                  cidadeId: id,
                  cidade: cidadeSel,
                  bairro: usaTaxaEntregaBairro ? '' : prev.bairro,
                  taxaEntregaBairroId: usaTaxaEntregaBairro ? null : prev.taxaEntregaBairroId
                }));
                if (usaTaxaEntregaBairro) {
                  setTaxaEntrega(0);
                  localStorage.removeItem('taxaEntregaBairroId');
                }
              }}
            >
              {/* <option value="">Todas as Cidades</option> */}
              {usaTaxaEntregaBairro && <option value="">Selecione a cidade</option>}
               {cidadesEntrega.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>
                  {cidade.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="endereco-modal-street-row">
            <div className="endereco-modal-field">
              <label htmlFor="endereco-rua">Rua/Avenida</label>
              <input
                id="endereco-rua"
                type="text"
                placeholder="Rua/Avenida"
                value={normalizeNullableInputValue(endereco?.logradouro)}
                onChange={(e) =>
                  setEndereco(prev => ({ ...prev, logradouro: e.target.value }))
                }
                className="modal-texto-input"
              />
            </div>
            <div className="endereco-modal-field">
              <label htmlFor="endereco-numero">Número</label>
              <input
                id="endereco-numero"
                type="text"
                placeholder="Número"
                value={normalizeNullableInputValue(endereco?.numero)}
                onChange={(e) =>
                  setEndereco(prev => ({ ...prev, numero: e.target.value }))
                }
                className="modal-texto-input endereco-modal-number"
              />
            </div>
          </div>
          <div className="endereco-modal-field">
            <label htmlFor="endereco-bairro">Bairro</label>
            {usaTaxaEntregaBairro ? (
              <>
                <select
                  id="endereco-bairro"
                  className="modal-texto-input"
                  value={endereco?.taxaEntregaBairroId || ''}
                  onChange={handleTaxaEntregaBairroChange}
                  disabled={!endereco?.cidadeId || carregandoTaxasBairro || !!erroTaxasBairro}
                >
                  <option value="">
                    {!endereco?.cidadeId ? 'Selecione a cidade' : erroTaxasBairro ? 'Erro ao carregar bairros' : carregandoTaxasBairro
                      ? 'Carregando bairros...'
                      : taxasBairroCidade.length === 0
                        ? 'Nenhum bairro cadastrado'
                        : 'Selecione o bairro'}
                  </option>
                  {taxasBairroCidade.map((taxa) => <option key={taxa.id} value={taxa.id}>{taxa.descricao}</option>)}
                </select>
                {erroTaxasBairro && <div className="endereco-modal-feedback erro" role="alert">{erroTaxasBairro} <button type="button" onClick={carregarTaxasEntregaBairro}>Tentar novamente</button></div>}
                {endereco?.taxaEntregaBairroId && <div className="endereco-modal-taxa">Taxa de entrega: <strong>{formatCurrency(taxaEntrega)}</strong></div>}
              </>
            ) : (
              <input
                id="endereco-bairro"
                type="text"
                placeholder="Bairro"
                value={normalizeNullableInputValue(endereco?.bairro)}
                onChange={(e) => setEndereco(prev => ({ ...prev, bairro: e.target.value }))}
                className="modal-texto-input"
              />
            )}
          </div>
          <div className="endereco-modal-field">
            <label htmlFor="endereco-complemento">Complemento <span>(opcional)</span></label>
            <input
              id="endereco-complemento"
              type="text"
              placeholder="Apartamento, bloco ou ponto de referência"
              value={normalizeNullableInputValue(endereco?.complemento)}
              onChange={(e) =>
                setEndereco(prev => ({ ...prev, complemento: e.target.value }))
              }
              className="modal-texto-input"
            />
          </div>
          <div className="modal-texto-buttons">          
            <button type="button" className="modal-texto-button-secondary" onClick={() => setShowModalInput(false)}>
              Cancelar
            </button>
            <button type="button" className="modal-texto-button" onClick={handleSaveEndereco}>
              Confirmar
            </button>
          </div>
        </div>
      </Modal>


    </>
  );
};

export default Endereco;
